import { render, staticRenderFns } from "./Shen.vue?vue&type=template&id=173804c8&scoped=true"
import script from "./Shen.vue?vue&type=script&lang=js"
export * from "./Shen.vue?vue&type=script&lang=js"
import style0 from "./Shen.vue?vue&type=style&index=0&id=173804c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173804c8",
  null
  
)

export default component.exports